import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Popup functionality
        let $buttons = $('.btn-popup');
        let $close  = $('.component.component-popup-2024 .close-modal');

        $buttons.each(function() {
            let $popup = $('.component.component-popup-2024');
            $(this).on("click", function (e) {
                e.preventDefault();
                $popup.fadeIn();
            });
            if ($close) {
                $close.on("click", function (e) {
                    e.preventDefault();
                    $popup.fadeOut();
                });
            }
            $(document).keyup(function(e) {
                if (e.key === "Escape") { // escape key maps to keycode `27`
                    e.preventDefault();
                    $popup.fadeOut();
                }
            });
        });

        // Form label animations
        const labelAnimations = () => {
            let $form   = $('.mktoForm');
            let $inputs = $form.find('input');
            $inputs.each(function() {
                let $this = $(this);
                $this.focusin(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
                $this.focusout(function() {
                    if (!$this.val()) {
                        $this.siblings('label').toggleClass('focused');
                        $this.toggleClass('focused');
                    }
                });
            })
        }

        labelAnimations();

    }
}
